var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 73,
    viewBox: "0 0 64 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1826 18.207L63.0488 18.4395H63.1826V54.8535H63.0225L31.5918 73L0.160156 54.8535H0V18.4395H0.133789L0 18.207L31.5361 0L31.5918 0.0957031L31.6475 0L63.1826 18.207ZM8.20898 22.9463V50.0205L31.5908 63.5205L54.9736 50.0205V22.9463L35.6963 11.8164V41.834H27.4873V11.8154L8.20898 22.9463ZM46.6035 20.9902V51.5068H46.5791L46.626 51.5889L31.5908 60.2686L31.5791 60.248L31.5674 60.2695L16.5332 51.5898L24.4863 46.7021L31.5791 50.7969L38.4404 46.835V16.5791L46.6035 20.9902Z",
    fill: "url(#paint0_linear_108_1176)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_1176",
    x1: 31.5913,
    y1: 5.26525,
    x2: 31.5913,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.91bc7d9f02a291a9f4ed9369cd2c2bde.svg";
export { ForwardRef as ReactComponent };